
import React, { useState } from "react";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation";
import Sidebar from "../common/Sidebar";
import CommonService from "../../services/CommonService";
import Swal from "sweetalert2";

const Fasttag = () => {

  const [vehicleNo, setVehicleNo] = useState("");
  const [fasttagDetails, setFasttagDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleFasttagSearch = () => {

    if (!vehicleNo) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter vehicle number"
      });
      return;
    }

    setIsLoading(true);

    const payload = {
      request_rc_number: vehicleNo
    };

    CommonService.fasttagDetails(payload)
      .then((response) => {

        console.log("API Response:", response.data);

        if (response.data.status === 200) {

          setFasttagDetails(response.data.data);

        } else {

          setFasttagDetails(null);

          Swal.fire({
            icon: "warning",
            title: "Message",
            text: response.data.message
          });

        }

        setIsLoading(false);

      })
      .catch((error) => {

        console.log("API Error:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Something went wrong"
        });

        setIsLoading(false);

      });
  };

  const handleReset = () => {
    setVehicleNo("");
    setFasttagDetails(null);
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">

          <Sidebar />

          <div className="layout-page">

            <Navigation />

            <div className="content-wrapper">

              <div className="container-xxl flex-grow-1 container-p-y">

                <div className="row">

                  <div className="col-md-12">

                    <div className="card">

                      <div className="card-body">

                        <h5 className="card-header">FASTag Details</h5>

                        <hr />

                        {isLoading ? (

                          <div className="d-flex justify-content-center mt-10 loader-overlay">
                            <div className="sk-fold sk-primary">
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                            </div>
                          </div>

                        ) : (

                          <>
                            <div className="row">

                              <div className="col-md-4">

                                <label>Vehicle Number</label>

                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Vehicle Number"
                                  value={vehicleNo}
                                  onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
                                />

                              </div>

                            </div>

                            <div className="pt-4">

                              <button
                                className="btn btn-primary me-2"
                                onClick={handleFasttagSearch}
                              >
                                Search
                              </button>

                              <button
                                className="btn btn-secondary"
                                onClick={handleReset}
                              >
                                Reset
                              </button>

                            </div>
                          </>
                        )}

                        {fasttagDetails && (

                          <div className="card mt-4">

                            <div className="card-body">

                              <h5>FASTag Details Result</h5>

                              <div className="row" style={{ background: "#ebe9e9" }}>

                                <div className="col-md-6">
                                  <b>Vehicle Number</b>
                                </div>

                                <div className="col-md-6 text-end">
                                  {fasttagDetails.vehicle_number || "NA"}
                                </div>

                              </div>

                              <div className="row">

                                <div className="col-md-6">
                                  <b>FASTag Bank</b>
                                </div>

                                <div className="col-md-6 text-end">
                                  {fasttagDetails.bank_name || "NA"}
                                </div>

                              </div>

                              <div className="row" style={{ background: "#ebe9e9" }}>

                                <div className="col-md-6">
                                  <b>Status</b>
                                </div>

                                <div className="col-md-6 text-end">
                                  {fasttagDetails.status || "NA"}
                                </div>

                              </div>

                            </div>

                          </div>

                        )}

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <Footer />

            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default Fasttag;

